export default __webpack_public_path__ + "static/media/sclerotherapy.72a7556e.pdf";